import { render, staticRenderFns } from "./notificar_boton.vue?vue&type=template&id=279cb580&lang=pug&"
import script from "./notificar_boton.vue?vue&type=script&lang=js&"
export * from "./notificar_boton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports